import { API_URL } from 'src/app/shared/enums/api-enums';
import { HttpParams } from '@angular/common/http';
import { SingleResponse } from './../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Injectable } from '@angular/core';
import { RequestOption } from '../model/common.model';
import { TYPE } from '../enums/admin-enum';

@Injectable({
  providedIn: 'root'
})
export class StayInformedService {

  baseUrl = environment.portalURL;
  type = 'application/json';
  constructor(
    private util: UtilitiesService
  ) { }

  getData(requestOption: RequestOption): Observable<SingleResponse<any>> {
    let params = new HttpParams();
    params = params.append('page', requestOption.pagingOptions.number.toString());
    params = params.append('size', requestOption.pagingOptions.size.toString());
    if (requestOption.pagingOptions.sort.sortBy && requestOption.pagingOptions.sort.sortOrder) {
      params = params.append('sortBy', requestOption.pagingOptions.sort.sortBy);
      params = params.append('sortDirection', requestOption.pagingOptions.sort.sortOrder);
    }
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.STAY_INFORMED + '?' + params);
  }

  getStayInformedById(id): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.STAY_INFORMED + '/' + id);
  }

  deleteInform(id): Observable<SingleResponse<any>> {
    return this.util.req.httpDelete<SingleResponse<any>>(this.baseUrl + API_URL.STAY_INFORMED + '/' + id);
  }

  addStayInformed(model) {
    const formData = new FormData();
    const request = {
      name: model.name,
      type: model.type,
      url: ''
    };
    if (model.type === TYPE.FILE && model.resource) {
      formData.append('file', model.resource);
    } else {
      request.url = model.url;
    }
    formData.append('stayInformed', new Blob([JSON.stringify(request)], {type: this.type}));
    return this.util.req.httpPost(this.baseUrl + API_URL.STAY_INFORMED, formData);
  }

  updateStayInformed(model, idStayInformed) {
    const formData = new FormData();
    const request = {
      id: idStayInformed,
      name: model.name,
      type: model.type,
      url: ''
    };
    if (model.type === TYPE.FILE && model.resource) {
      formData.append('file', model.resource);
    } else {
      request.url = model.url;
    }
    formData.append('stayInformed', new Blob([JSON.stringify(request)], {type: this.type}));
    return this.util.req.httpPut(this.baseUrl + API_URL.STAY_INFORMED, formData);
  }
}
